"use client";

import { PushNotificationRecordStatus } from "@/backend/focus";
import { useConfirm } from "@/components/ui/confirm";
import { useToast } from "@/components/ui/use-toast";
import { usePushNotifications } from "@/hooks/use-push-notification";
import { getNotificationGrantPermission } from "@/utils/notifications";

export const usePushNotificationsPopup = () => {
  const { confirm } = useConfirm();
  const { toast } = useToast();
  const { subscribeToNotifications } = usePushNotifications();

  return {
    showNotificationsPopup: async () => {
      if (getNotificationGrantPermission() !== "default") {
        return;
      }

      const result = await confirm({
        title: "Subscribe to Push Notifications",
        description: (
          <p>
            Get notified when you receive a tip, subscription, paid message, and
            more.
          </p>
        ),
        primaryCTA: "Subscribe me",
        cancelCTA: "Skip for now",
      });

      if (result) {
        toast({
          title: "Subscribing to push notifications...",
          description: "Please accept the permission popup in your browser.",
        });

        if (
          await subscribeToNotifications(PushNotificationRecordStatus.ACTIVE)
        ) {
          toast({
            title: "Successfully subscribed to push notifications!",
          });
        }
      }
    },
  };
};
